import { render } from "./EditInactive.vue?vue&type=template&id=29a76d02"
import script from "./EditInactive.vue?vue&type=script&lang=js"
export * from "./EditInactive.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__